module.exports = {
  mobile: {
    name: "Myfitsociety | #1 Best Fitness & Diet App For Body Goals",
    desc: "Achieve your body goals easier. Access 150+ quick workouts, diet program, and meditation all in one app.",
    prefix: "myfitsociety",
    footerText: "Myfitsociety",
    logoText: "Myfitsociety",
    projectName: "Myfitsociety",
    url: process.env.URL,
    img: "/static/images/mobile-logo.png",
    notifMsg: "Achieve your body goals easier. Access 150+ quick workouts, diet program, and meditation all in one app.",
    mfs: "Myfitsociety | #1 Best Fitness & Diet App For Body Goals",
    ogImg: "/static/images/mfs/og-fb-001.jpeg",
    domain: process.env.DOMAIN,
    locale: "en_US",
    ogType: "website",
    title: "Myfitsociety"
  }
};
